import { array } from 'yup'

const MinimumJobsites = (roleField, roleValue, minimumMessage) => array().when(roleField, {
  is: roleValue,
  then: array().required(minimumMessage).min(1, minimumMessage),
  otherwise: array().notRequired()
})

export default MinimumJobsites
